<template>
  <div class="tab-body">
    <div class="search">
      <el-form ref="form" :model="searchParams" label-width="80px">
        <el-row>
          <el-col :span="6">
            <el-form-item label="班级">
              <el-input v-model="searchParams.clz"></el-input> 
            </el-form-item>
          </el-col>
      
          <el-col :span="6">
            <el-form-item label="姓名">
              <el-autocomplete
                v-model="searchParams.name"
                :fetch-suggestions="querySearchAsync"
                placeholder="请输入内容"
                @select="handleSelect"
              ></el-autocomplete>
              <!-- <el-input v-model="searchParams.name"></el-input> -->
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="状态">
              <el-select v-model="state" @change="search" placeholder="请选择">
                <el-option
                  v-for="itm in [{key:1,val:'在读'}, {key:2,val:'休学'}, {key:3,val:'毕业'},{key:4,val:'待报到'},{key:5,val:'退学'}, {key:0,val:'全部'}]"
                  :key="itm.val"
                  :label="itm.val"
                  :value="itm.key"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-collapse-transition>
            <div v-if="isShowMoreSearch">
              <!--隐藏区域-->
            </div>
          </el-collapse-transition>
          <div class="search-btn">
            <el-button type="primary" icon="el-icon-search" @click="search"
              >搜索</el-button
            >
            <el-button @click="clearSearchVal">清空</el-button>
          </div>
        </el-row>
      </el-form>
    </div>
    <div class="operator">
      <el-button type="primary" icon="el-icon-plus" @click="toSave()"        size="mini"
        >添加</el-button
      >
      <el-button type="success" icon="el-icon-plus" @click="toImport()"        size="mini"
        >导入</el-button
      >
      <el-button type="primary" icon="el-icon-plus" @click="toExport()"        size="mini"
        >下载导入模板</el-button
      >
      <el-button type="warning" icon="el-icon-delete" @click="relaxXCX()"        size="mini"
        >小程序解除绑定</el-button
      >
      <el-button type="danger" icon="el-icon-delete" @click="batchRemove()"        size="mini"
        >批量删除</el-button
      >
      <el-button type="success"  @click="batchState2()"        size="mini"
        >置可用</el-button
      >
      <el-button type="danger"  @click="batchState1()"        size="mini"
        >置停用</el-button
      >
      
   
    </div>
    <div class="dataTable autoFlex" v-if="listData">
      <el-table
        class="table"
        :data="listData.records"
        stripe
        border
        @selection-change="selectionChange"
        height="auto"
        v-loading="listLoading"
      >
        <el-table-column
          type="selection"
          width="55"
          fixed="left"
        ></el-table-column>
        <el-table-column prop="name" width="110" label="学生">
          <template slot-scope="scope">
            <el-tag size="mini">{{ scope.row.name }}</el-tag><br>
            <el-tag size="mini" :type="scope.row.isdisable==1?'danger':'success'"> {{ scope.row.isdisable==1?'停用':'正常' }}</el-tag>
          </template>
        </el-table-column>
 
        <!-- <el-table-column prop="dbColumn_cid" label="班级名称"></el-table-column> -->
        <el-table-column prop="head"  width="80"  label="头像">
          <template slot-scope="scope">
            <el-avatar
              size="large"
              :src="scope.row.head"
              v-if="scope.row.head"
            ></el-avatar>
          </template>
        </el-table-column>
        <el-table-column prop="sex" width="65" label="性别">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.sex == 1" size="mini">男</el-tag>
            <el-tag v-if="scope.row.sex == 2" size="mini" type="danger"
              >女</el-tag>
            <el-tag  type="success" v-if="scope.row.state == 1" size="mini">在读</el-tag>
            <el-tag  type="danger"  v-if="scope.row.state == 2" size="mini">休学</el-tag>
            <el-tag v-if="scope.row.state == 3" size="mini">毕业</el-tag>
            <el-tag v-if="scope.row.state == 4" size="mini">待报到</el-tag>
            <el-tag v-if="scope.row.state == 5" size="mini">退学</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="mobile" width="140" label="电话&班级">
          <template slot-scope="scope">
            <el-tag size="mini"  >{{
              scope.row.mobile
            }}</el-tag>
          <el-tag size="mini" type="warning">{{
              scope.row.dbColumn_cid
            }}</el-tag>
        </template>
        </el-table-column>
 
        <el-table-column prop="school" label="学校&专业">
          <template slot-scope="scope">
            <el-tag size="mini">{{ scope.row.school }}</el-tag>
            <br />
            <el-tag size="mini" type="success">{{ scope.row.subject }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="xueli" width="100"  label="籍贯/学历">
          <template slot-scope="scope">
             {{ scope.row.jiguan }}/{{ scope.row.xueli }} 
          </template>
        </el-table-column>
      
        <el-table-column
          prop="schooltime"
          width="100"
          label="报到时间"
        > <template slot-scope="scope">
          <el-tag size="mini" type="success">{{ scope.row.schooltime }}</el-tag>
          </template></el-table-column>

        <el-table-column prop="agreets" width="70" label="订阅">
          <template slot-scope="scope">
            <el-tag size="mini" v-if="!scope.row.wxappopenid" type="warning">待绑定</el-tag>
            <el-tag size="mini" v-else-if="scope.row.agreets == 1" type="success">同意</el-tag>
            <el-tag size="mini" v-else  type="danger"> 不同意 </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="historyclass" width="80" label="转班记录">
          <template slot-scope="scope">
            <el-tag
              size="mini"
              v-if="scope.row.historyclass"
              @click="showHistoryClass(scope.row.historyclass)"
              >查看</el-tag
            >
            <el-tag size="mini" v-else
              >无</el-tag
            >
        
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="320px">
          <template slot-scope="scope">
            <div class="dataTable-operator">
              <el-button size="mini" @click="toDetail(scope.$index, scope.row)"
                >详情</el-button
              >
              <el-button size="mini" @click="toUpdate(scope.$index, scope.row)"
                >编辑</el-button >
              <el-button title="重置密码为班级默认密码"  type="warning" size="mini" @click="revise(scope.$index, scope.row)"
                >密码重置</el-button
              >
              <el-button
                size="mini"
                type="danger"
                @click="remove(scope.$index, scope.row)"
                >删除</el-button
              >
        
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pageBar">
        <el-pagination
          @size-change="sizeChange"
          @current-change="currentChange"
          :total="listData.total"
          :page-size="page.size"
          :current-page="page.current"
          :layout="this.$constant.page.layout"
          :page-sizes="this.$constant.page.pageSizes"
        ></el-pagination>
      </div>
    </div>
    <div>
      <el-dialog
        title="转班纪录查看"
        :visible.sync="dialogVisible2"
        width="22%"
      >
        <span>无 </span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible2 = false">取 消</el-button>
          <el-button type="primary" @click="dialogVisible2 = false"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
    <el-dialog title="上传学生信息" :visible.sync="dialogVisible" width="30%">
      <excel-upload
        drag
        model="fileSystem"
        uri="/statics/excels"
        :size="upsize"
        v-on:change="uploadSuccess"
      >
      </excel-upload>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <edit ref="edit"></edit>
    <show @flush="list()" ref="show"></show>
  </div>
</template>
<script>
import show from "./showUpdata.vue";
import edit from "./edit.vue";
import api from "@/api/stus/student/student.js";
import excelUpload from "@/components/biz/fileUpload/excelUpload.vue";


export default {
  name: "student",
  components: {
    edit,
    excelUpload,
    show,
  },
  data() {
    return {
      state: 1,
      searchParams: {},
      urlList: {},
      isShowMoreSearch: false,
      listLoading: false,
      listData: [],
      selected: [],
      page: new this.$constant.pageObj(),
      upsize: "512",
      dialogVisible: false,
      dialogVisible2: false,
    };
  },
  methods: {
    batchState1(){
      this.$utils.confirm.warning("提示", "确定将选中的学生置为【停用】状态1吗？", () => {
        api.chgState1(
          {
            ids: this.selected
          },
          (response) => {
            this.$utils.msg.success(response.msg);
            this.list();
          },
          (response) => {
            this.$utils.msg.warning(response.msg);
          }
        );
      });
    },
    batchState2(){
      this.$utils.confirm.warning("提示", "确定将选中的学生置为【可用】状态2吗？", () => {
        api.chgState2(
          {
            ids: this.selected
          },
          (response) => {
            this.$utils.msg.success(response.msg);
            this.list();
          },
          (response) => {
            this.$utils.msg.warning(response.msg);
          }
        );
      });
    },
    relaxXCX(){
      if (!this.selected || this.selected.length == 0) {
        this.$utils.msg.info("请选择至少一行");
        return;
      }
      let parameter = {
        ids: this.selected,
      };
      this.$utils.confirm.warning("提示", "确定微信小程序解除绑定吗？", () => {
        api.reBind(
          {
            ids: this.selected,
          },
          (response) => {
            this.$utils.msg.success(response.msg);
            this.list();
          },
          (response) => {
            this.$utils.msg.warning(response.msg);
          }
        );
      });
    },
    querySearchAsync(queryString, cb) {
      if (queryString && queryString.length > 0) {
        api.getStulist({ name: queryString }, (res) => {
          let stus = res.data;
          let results = queryString
            ? stus.filter(this.studentsFilter(queryString))
            : stus;
          cb(results);
        });
      }
    },
    studentsFilter(queryString) {
      return (stu) => {
        stu.value = stu.name;
        return stu.value.indexOf(queryString) === 0;
      };
    },
    handleSelect(item) {
      this.searchParams.name = item.name;
      this.search()
    },
    toExport() {
      var a = document.createElement("a"); //创建一个<a></a>标签
      console.log("a: ", a);
      a.href = "/static/stu.xlsx"; // 给a标签的href属性值加上地址
      a.download = "学生信息导入模板.xlsx"; //设置下载文件文件名，这里加上.xlsx指定文件类型
      console.log("a: ", a);
      a.style.display = "none"; // 障眼法藏起来a标签
      document.body.appendChild(a); // 将a标签追加到文档对象中
      console.log("a: ", a);
      a.click(); // 模拟点击了a标签，会触发a标签的href的读取
      a.remove(); // 一次性的，用完就删除a标签
    },
    showHistoryClass(t) {
      // this.urlList = JSON.parse(t);
      this.dialogVisible2 = true;
      // console.log(this.urlList);
    },
    //去导入
    toImport: function() {
      this.dialogVisible = true;
    },

    uploadSuccess(res) {
      // console.log(res);
      if (res && res.length > 32) {
        this.$utils.msg.success("上传成功");
        this.dialogVisible = false;
        let fnm = res.substr(res.lastIndexOf("/") + 1);

        api.toImport({ fn: fnm }, (res2) => {
          console.log("res2.data: ", res2.data);
          this.$refs.show.open(res2.data, "确认导入数据");
        });
      } else {
        this.$utils.msg.warning("上传fail,亲联系管理员.");
      }
    },
    //获取数据
    list() {
      this.listLoading = true;
      if (this.state){
        this.searchParams.state  =this.state
      }else  {
        delete this.searchParams.state  
      }
      let params = this.$utils.merger(this.searchParams, this.page);
      if(params.clz && params.clz.length<=1){
           delete params.clz
      }
      api.list(params, (response) => {
        this.listData = response.data;
        this.listLoading = false;
      });
    },
    //重置密码
    revise(index, row) {
      let parameter = row.id;
      this.$utils.confirm.warning("提示", "确定重置密码吗？", () => {
        api.revise(
          {
            id: parameter,
          },
          (response) => {
            this.$utils.msg.success(response.msg);
            this.list();
          },
          (response) => {
            this.$utils.msg.warning(response.msg);
          }
        );
      });
    },reBind(index, row) {//重新绑定
      let parameter = row.id;
      this.$utils.confirm.warning("提示", "确定重置学生小程序绑定吗？", () => {
        api.reBind(
          {
            id: parameter,
          },
          (response) => {
            this.$utils.msg.success(response.msg);
            this.list();
          },
          (response) => {
            this.$utils.msg.warning(response.msg);
          }
        );
      });

    },
    //去添加
    toSave() {
      this.$refs.edit.open({}, "添加");
      //this.$refs.edit.mo();
    },
    //去编辑
    toUpdate(index, row) {
      let editParameter = {
        id: row.id,
      };
      let cid = row.cid;
      this.$refs.edit.open(editParameter, "编辑", false, cid);
    },
    //去详情
    toDetail(index, row) {
      let detailParameter = {
        id: row.id,
      };
      this.$refs.edit.open(detailParameter, "详情", true);
    },
    //删除
    remove(index, row) {
      let parameter = {
        ids: row.id,
      };
      this.$utils.confirm.warning("提示", "确定删除吗？", () => {
        api.remove(
          parameter,
          (response) => {
            this.$utils.msg.success(response.msg);
            this.list();
          },
          (response) => {
            this.$utils.msg.warning(response.msg);
          }
        );
      });
    },
    //批量删除
    batchRemove() {
      if (!this.selected || this.selected.length == 0) {
        this.$utils.msg.info("请选择至少一行");
        return;
      }
      let parameter = {
        ids: this.selected,
      };
      this.$utils.confirm.warning("提示", "确定删除吗？", () => {
        api.remove(
          {
            ids: this.selected,
          },
          (response) => {
            this.$utils.msg.success(response.msg);
            this.list();
          },
          (response) => {
            this.$utils.msg.warning(response.msg);
          }
        );
      });
    },
    //改变选择项
    selectionChange(val) {
      //清空
      this.selected = [];
      for (let item of val) {
        this.selected.push(item.id);
      }
    },
    //改变每页显示数量
    sizeChange(val) {
      this.page.size = val;
      this.list();
    },
    //改变现在的页码
    currentChange(val) {
      this.page.current = val;
      this.list();
    },

    //搜索
    search() {

      this.listLoading = true;
      this.page.current = 1;
      this.list();
    },
    //清空搜索框
    clearSearchVal() {
      this.searchParams = {};
      this.list();
    },
  },
  mounted() {
    this.list();
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
</style>
